import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsumoDetalharComponent } from './consumo-detalhar.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ConsumoDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class ConsumoDetalharRoutingModule { }
